import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Gallery", to: "/gallery" },
  { label: "Services", to: "/services" },
  { label: "Additional Services Offered", to: "/other-services" },
  { label: "About", to: "/about" },
  { label: "Request a Quote", to: "/quote" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="font-serif-display text-xl sm:text-2xl tracking-tight text-[#1E352F] leading-none"
        >
          Flathead<span className="text-[#A95C42]">.</span>
          <span className="block text-[10px] tracking-[0.3em] uppercase font-sans font-semibold text-[#4A5D54] mt-0.5">
            Trail Systems
          </span>
        </Link>

        <button
          data-testid="nav-hamburger-button"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          className="flex items-center gap-2 text-[#1E352F] hover:text-[#A95C42] transition-colors"
        >
          <span className="hidden sm:inline text-xs tracking-[0.2em] uppercase font-semibold">
            Menu
          </span>
          <Menu className="h-7 w-7" strokeWidth={1.5} />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="fixed inset-0 bg-[#1E352F] text-[#F8F7F4] flex flex-col"
          >
            <div className="max-w-7xl w-full mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
              <span className="font-serif-display text-2xl">Flathead Trail Systems</span>
              <button
                data-testid="nav-close-button"
                onClick={() => setOpen(false)}
                aria-label="Close menu"
                className="hover:text-[#A95C42] transition-colors"
              >
                <X className="h-8 w-8" strokeWidth={1.5} />
              </button>
            </div>

            <nav className="flex-1 max-w-7xl w-full mx-auto px-6 md:px-12 flex flex-col justify-center gap-2">
              {LINKS.map((link, i) => (
                <motion.button
                  key={link.to}
                  data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => go(link.to)}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 + i * 0.08, duration: 0.4 }}
                  className="group text-left font-serif-display text-5xl sm:text-7xl tracking-tight text-[#F8F7F4] hover:text-[#A95C42] transition-colors py-2 flex items-baseline gap-4"
                >
                  <span className="font-sans text-xs tracking-widest text-[#7E9384] group-hover:text-[#A95C42]">
                    0{i + 1}
                  </span>
                  {link.label}
                </motion.button>
              ))}
            </nav>

            <div className="max-w-7xl w-full mx-auto px-6 md:px-12 py-8 border-t border-[#3C5A4C] text-sm text-[#A7B8AE] flex flex-col sm:flex-row flex-wrap gap-2 sm:gap-8">
              <span>Jonathan Oftedahl · Kalispell, Montana</span>
              <a href="tel:+14064713203" className="hover:text-[#F8F7F4]">
                (406) 471-3203
              </a>
              <a href="mailto:Jonathan@flatheadtrailsystems.com" className="hover:text-[#F8F7F4]">
                Jonathan@flatheadtrailsystems.com
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
